import { UseMutationResult } from '@tanstack/react-query'
import { graphql } from 'src/gql'
import { MutateDeleteReportBuilderReportMutation, MutateDeleteReportBuilderReportMutationVariables } from 'src/gql/graphql'
import { useGraphMutation } from 'src/hooks/useGraphMutation'

const document = graphql(/* graphql */`
  mutation mutateDeleteReportBuilderReport($id: MongoID!) {
    cat {
      reporting {
        builder {
          report {
            deleteById(_id: $id) {
              recordId
            }
          }
        }
      }
    }
  }
`)

export type UseMutateDeleteReportBuilderReportReturn = UseMutationResult<
MutateDeleteReportBuilderReportMutation,
unknown,
MutateDeleteReportBuilderReportMutationVariables
>

const useMutateDeleteReportBuilderReport = (): UseMutateDeleteReportBuilderReportReturn => {
  return useGraphMutation(document)
}

export { useMutateDeleteReportBuilderReport, document as mutateDeleteReportBuilderReportDocument }
